<template>
  <div class="absolute right-0 p-4 z-50">
    <ul>
      <!-- home extent button  -->
      <p class="group">
        <map-button @clicked="homeExtent" icon="fas fa-house" />
        <span class="flex relative justify-end">
          <span class="tooltip whitespace-nowrap">Feature Extent</span>
        </span>
      </p>
      <!-- zoom in button -->
      <p class="group">
        <map-button @clicked="zoom(1)" icon="fas fa-plus" />
        <span class="flex relative justify-end">
          <span class="tooltip whitespace-nowrap">Zoom In</span>
        </span>
      </p>

      <!-- zoom out button  -->
      <p class="group">
        <map-button @clicked="zoom(-1)" icon="fas fa-minus" />
        <span class="flex relative justify-end">
          <span class="tooltip whitespace-nowrap">Zoom Out</span>
        </span>
      </p>
      <!-- time slider button  -->
      <p class="group" v-if="canBeTimeEnabled">
        <map-button @clicked="toggleTimeTool" :active="showTimeTool" icon="fas fa-clock" />
        <span class="flex relative justify-end">
          <span class="tooltip whitespace-nowrap">Time Tool</span>
        </span>
      </p>
    </ul>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import MapButton from '@/components/map-components/buttons/MapButton'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'MapButtonContainer',
  components: { MapButton },
  props: {
    stateModule: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore()
    const canBeTimeEnabled = computed(() => {
      return store.getters[`${props.stateModule}/canBeTimeEnabled`]
    })

    const showTimeTool = computed(() => {
      return store.state.TimeTool.active
    })

    function toggleTimeTool() {
      store.dispatch('TimeTool/toggle')
    }

    function zoom(index) {
      store.dispatch(props.stateModule + '/zoom', index)
    }

    function homeExtent() {
      store.dispatch(props.stateModule + '/home')
    }
    return { zoom, homeExtent, canBeTimeEnabled, showTimeTool, toggleTimeTool }
  },
}
</script>

<style scoped>

</style>
